import { Component } from '@angular/core';

@Component({
  selector: 'app-bpg-membership',
  templateUrl: './bpg-membership.component.html',
  styleUrls: ['./bpg-membership.component.css']
})
export class BpgMembershipComponent {

  constructor() { }


}
